import { getDict,setDict } from '@/assets/js/config';
import { Decimal } from 'decimal.js';
import bus from '@/assets/js/bus';
import { getUserName,isSuperUser } from './assets/js/user';

export default {
    install(Vue) {
        Vue.prototype.showLoadingBox = function(){bus.$emit('showLoadingBox');}
        Vue.prototype.hideLoadingBox = function(){bus.$emit('hideLoadingBox');}

        Vue.prototype.showConnectWalletBox = function(msg){bus.$emit('showConnectWalletBox',msg);}
        Vue.prototype.hideConnectWalletBox = function(){bus.$emit('hideConnectWalletBox');}

        Vue.prototype.showConfirmBox = function(type,token1,token2){
            if(!token1){
                token1 = "";
            }
            if(!token2){
                token2 = "";
            }
            bus.$emit('showConfirmBox',{type:type,token1:token1,token2:token2});
        }
        Vue.prototype.hideConfirmBox = function(msg){bus.$emit('hideConfirmBox',msg);}
        Vue.prototype.setConfirmBox = function(type){bus.$emit('setConfirmBox',type);}

        //过滤编辑器内容中的<script>标签
        Vue.prototype.filterEditorContent = function(content){
            content = content.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
            return content;
        }
        //获取编辑器内容中的所有文字内容，前100个字符
        Vue.prototype.getHtmlText = function(val){
            if (val != null && val != "") {
                var re1 = new RegExp("<.+?>|&.+?;", "g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
                var msg = val.replace(re1, ""); //执行替换成空字符
                msg = msg.replace(/\s/g, ""); //去掉所有的空格（中文空格、英文空格都会被替换）
                msg = msg.replace(/[\r\n]/g, ""); //去掉所有的换行符
                if(msg.length>55){
                    return msg.substr(0, 50)+"..."; //获文本文字内容的前100个字符
                }
                return msg;
            }
            return ''
        }
        Vue.prototype.showApy = function(apy) {
            return (apy*100).toFixed(2)+"%";
        }
        Vue.prototype.showRate = function(rate) {
            if(rate>0){
                return "+"+(rate*100).toFixed(2)+"%";
            }
            return (rate*100).toFixed(2)+"%";
        }
        Vue.prototype.getUserName = function(){
            return getUserName();
        }
        Vue.prototype.showAddress = function(address) {
            if(!address){
                return "";
            }
            if (address.length <= 10) {
                return address;
            }
            return address.slice(0, 6) + "..." + address.slice(-4);
        }
        Vue.prototype.showHash = function(txHash) {
            if(!txHash){
                return "";
            }
            if (txHash.length <= 15) {
                return txHash;
            }
            return txHash.slice(0, 8) + "..." + txHash.slice(-8);
        }
        Vue.prototype.isSuperUser = function(){
            return isSuperUser();
        }
        Vue.prototype.formatDate = function(date){
            //年份
            let Year = date.getFullYear(); 
            //月份下标是0-11
            let Months = ( date.getMonth() + 1 ) < 10  ?  '0' + (date.getMonth() + 1) : ( date.getMonth() + 1); 
            //具体的天数
            let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            //小时
            let Hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            //分钟
            let Minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            //秒
            let Seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            //返回数据格式
            return Year + '-' + Months + '-' + Day + ' ' + Hours + ':' + Minutes + ':' + Seconds; 
        }
        Vue.prototype.formatDate2 = function(date){
            //年份
            let Year = date.getFullYear(); 
            //月份下标是0-11
            let Months = ( date.getMonth() + 1 ) < 10  ?  '0' + (date.getMonth() + 1) : ( date.getMonth() + 1); 
            //具体的天数
            let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            //返回数据格式
            return Year + '-' + Months + '-' + Day; 
        }
        Vue.prototype.formatTimestamp = function(timestamp){
            if(timestamp == null || timestamp == "" || timestamp == undefined){
                return "";
            }
            let date = new Date(timestamp);
            //年份
            let Year = date.getFullYear(); 
            //月份下标是0-11
            let Months = ( date.getMonth() + 1 ) < 10  ?  '0' + (date.getMonth() + 1) : ( date.getMonth() + 1); 
            //具体的天数
            let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            //小时
            let Hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            //分钟
            let Minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            //秒
            let Seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            //返回数据格式
            return Year + '-' + Months + '-' + Day + ' ' + Hours + ':' + Minutes + ':' + Seconds; 
        }
        Vue.prototype.toDecimalVal = function(val,xs){
            if(val == null || val == undefined){
                return 0;
            }
            let str = new Decimal(val).toFixed(xs,Decimal.ROUND_DOWN);
            if (!(/^[0-9.]+$/g.test(str))) return '0';
            while (str.includes(".") && (str.endsWith('.') || str.endsWith('0'))) {
                str = str.slice(0, -1)
            }
            return str;
        }
        Vue.prototype.listToMap = function(array, keyName,valueName){
            let map = {};
            array.forEach(function (item) {
                map[item[keyName]] = item[valueName];
            });
            return map;
        };
        Vue.prototype.listToMap2 = function(array, keyName){
            let map = {};
            if(array){
                array.forEach(function (item) {
                    map[item[keyName]] = item;
                });
            }
            return map;
        };
        

        Vue.prototype.groupBy = function(array, name){
            let groups = {};
            array.forEach(function (item) {
                 let group = item[name];
                 groups[group] = groups[group] || [];
                 groups[group].push(item);
            });
            return groups;
        };

        Vue.prototype.statusOptions = [
            { value: 'NORMAL', label: '正常' },
            { value: 'DISABLED', label: '禁用' }
        ];
        Vue.prototype.statusMap = Vue.prototype.listToMap(Vue.prototype.statusOptions,"value","label");
        Vue.prototype.yesOrNoOptions =  [
            { value: 'Y', label: '是' },
            { value: 'N', label: '否' }
        ];

        Vue.prototype.findDict = function(type){
            let allDictList = getDict();
            return allDictList.filter(tt => tt.type == type);
        }

        Vue.prototype.makeKeyMap = function(options){
            let map = {};
            for (let temp of options) {
              map[temp.value + ""] = temp.label
            }
            return map;
        };
        Vue.prototype.isMobile =  function() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            return flag;
        }
    }
}

  